import React, { Component } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Navigate } from 'react-router';
import { makeLinks, withRouter } from 'utils/common';
import { partial } from 'underscore';
import axios from 'axios';
import moment from 'moment';
import EventDetails from './Pages/EventDetails';
import Confirmation from './Pages/Confirmation';
import endpoints from 'utils/endpoints';
import Payment from './Pages/Payment';
import PersonalData from 'components/PersonalData';
import PaymentSuccess from 'components/PaymentSuccess';
import PaymentError from 'components/PaymentError';
import Head from 'components/Head';
import i18n from 'utils/translate';
import { PAYMENT_RESPONSE } from 'utils/constants';
import { isAustrianIBAN } from 'utils/common';
import { toast } from 'react-toastify';
import ErrorMessage from 'components/ErrorMessage';
import SummaryBox from 'components/SummaryBox';
import { EVENT_TYPE_SMALL, EVENT_TYPE_LARGE } from './constants';

const steps = [
  { text: 'Versicherung', url: '', icon: 'insurance' },
  { text: 'Personendaten', url: 'person', icon: 'identification' },
  { text: 'Zahlung', url: 'payment', icon: 'wallet' },
  { text: 'Abschluss', url: 'confirmation', icon: 'badge' }
];

class PromInsurance extends Component {
  constructor(props) {
    super(props);

    this.params = {};
    this.blockPayment = false;

    this.state = {
      loading: false,
      apiErrorMessages: []
    };

    this.initializeData();

    this.steps = steps.map(step => ({
      ...step,
      path: `${step.path}`
    }));

    this.urls = {
      prom: '/',
      personal: '/person',
      payment: '/payment',
      confirm: '/confirmation',
      success: '/success',
      error: '/error'
    };
  }

  initializeData = () => {
    this.data = {
      personal: {},
      event: {},
      payment: {},
      documents: {}
    };
  };

  updateData = (key, value) => {
    this.data[key] = value;
    this.setState({ [key]: value });
  };

  makeQuoteModel({ veranstaltungsArt, veranstaltungsDatum, veranstaltungsOrt, schuleUndKlasse }) {
    const { anrede, vorname, nachname, geburtsdatum, strasse, nr, plz, ort, email, telefon } = this.data.personal;

    const { promotion } = this.data.payment;

    return {
      veranstaltungsArt,
      veranstaltungsDatum: moment(veranstaltungsDatum).format('DD.MM.YYYY'),
      veranstaltungsOrt,
      schuleUndKlasse,
      graweInfos: promotion,
      versicherter: {
        anrede,
        vorname,
        nachname,
        geburtsdatum: moment(geburtsdatum).format('DD.MM.YYYY'),
        strasse,
        nr,
        plz,
        ort,
        email,
        telefon,
        land: 'AT'
      }
    };
  }

  makeOrderModel() {
    const data = this.makeQuoteModel(this.data.event);
    const {
      payment: { type, iban, bic }
    } = this.data;

    return {
      ...data,
      bezahlung: {
        type: type === 'sepa' ? 'sepa' : 'erlagschein',
        iban: type === 'sepa' ? iban.replace(/\s+/g, '') : undefined,
        bic: type === 'sepa' ? (isAustrianIBAN(iban) ? '' : bic) : undefined,
        paymentMethod: type === 'sepa' ? 'SEPA_DIRECTDEBITMANDATE' : 'ERLAGSCHEIN'
      }
    };
  }

  calculateQuote = eventDetails => {
    const veranstaltungsArt =
      eventDetails.veranstaltungsArt !== null ? eventDetails.veranstaltungsArt : this.data.veranstaltungsArt;

    return axios({
      baseURL: GRAWE.api_root,
      url: endpoints.prom.GET_PRICE,
      method: 'post',
      data: { veranstaltungsArt },
      withCredentials: true
    })
      .then(response => response.data)
      .then(({ ok, praemie: price, waehrung: currency, validierungsMeldungen }) => {
        if (!ok) {
          validierungsMeldungen.forEach(error => {
            toast.error(<ErrorMessage header={error.feld} message={error.validierungsText} />);
          });
          return { validierungsMeldungen };
        } else {
          toast.dismiss();
          return { price, currency, validierungsMeldungen };
        }
      })
      .catch(() => null)
      .then(quote => (this.data.quote = quote));
  };

  resetApiErros = () => {
    this.setState({
      apiErrorMessages: []
    });
  };

  placeSepaOrder() {
    const data = this.makeOrderModel();
    const { navigate } = this.props.router;

    return axios({
      baseURL: GRAWE.api_root,
      url: endpoints.prom.SEPA,
      method: 'post',
      data
    })
      .then(resp => resp.data)
      .then(
        ({ validierungsMeldungen: errors, status }) => {
          if (status === PAYMENT_RESPONSE.ERROR) {
            const apiErrors = [{ validierungsText: `${i18n('SEPA-Zahlung fehlgeschlagen')}` }];
            this.setState({
              apiErrorMessages: apiErrors,
              status: status
            });
          } else {
            this.setState({
              status: status
            });
            navigate('/success');
          }
          this.setState({
            loading: false
          });
        },
        () => {
          this.setState({
            loading: false,
            apiErrorMessages: [{ validierungsText: `${i18n('SEPA-Zahlung fehlgeschlagen')}` }]
          });
        }
      );
  }

  placePaymentSlipOrder() {
    const data = this.makeOrderModel();
    const { navigate } = this.props.router;

    return axios({
      baseURL: GRAWE.api_root,
      url: endpoints.prom.PAYMENT_SLIP,
      method: 'post',
      data
    })
      .then(resp => resp.data)
      .then(
        ({ validierungsMeldungen: errors, status }) => {
          if (status === PAYMENT_RESPONSE.ERROR) {
            const apiErrors = [{ validierungsText: `${i18n('Erlagschein-Zahlung fehlgeschlagen')}` }];
            this.setState({
              apiErrorMessages: apiErrors,
              status: status
            });
          } else {
            this.setState({
              status: status
            });
            navigate('/success');
          }
          this.setState({
            loading: false
          });
        },
        () => {
          this.setState({
            loading: false,
            apiErrorMessages: [{ validierungsText: `${i18n('Erlagschein-Zahlung fehlgeschlagen')}` }]
          });
        }
      );
  }

  placeOrder = () => {
    const {
      payment: { type: payment_type }
    } = this.data;

    this.setState({
      loading: true
    });

    if (payment_type === 'sepa') {
      this.placeSepaOrder();
    } else {
      this.placePaymentSlipOrder();
    }
  };

  makeLinks(previous, current, next) {
    const { navigate, location } = this.props.router;

    return makeLinks(previous, current, next, navigate, location);
  }

  renderEventDetailsPage = () => {
    const props = {
      calculateQuote: this.calculateQuote,
      ...this.makeLinks(null, this.urls.prom, this.urls.personal),
      onChange: partial(this.updateData, 'event'),
      data: this.data.event
    };
    return <EventDetails {...props} />;
  };

  renderSummaryBox() {
    const {
      event: { veranstaltungsArt, veranstaltungsDatum, veranstaltungsOrt, schuleUndKlasse },
      quote
    } = this.data;

    const displayPrice = +quote?.price ?? 0;

    let eventTypeText;
    switch (veranstaltungsArt) {
      case EVENT_TYPE_SMALL:
        eventTypeText = i18n('Maturaball mit max. 1.000 Teilnehmern und Gästen');
        break;
      case EVENT_TYPE_LARGE:
        eventTypeText = i18n('Maturaball mit max. 5.000 Teilnehmern und Gästen');
        break;
      default:
        eventTypeText = '';
    }

    const sections = {
      eventType: eventTypeText,
      insuranceSum: i18n('€ 2.000.000,- für Personen- und Sachschäden'),
      eventDate: veranstaltungsDatum,
      location: veranstaltungsOrt,
      schoolAndClass: schuleUndKlasse
    };

    return (
      <SummaryBox
        title={i18n('Zusammenfassung')}
        sections={sections}
        finalPrice={displayPrice}
        currency={quote && quote.currency}
        quoteType="once"
      />
    );
  }

  renderPersonalDetailsPage = () => {
    const { personal, quote } = this.data;

    if (Object.keys(this.data.event).length < 5) {
      return <Navigate replace to={this.urls.prom} />;
    }

    const props = {
      ...this.makeLinks(this.urls.prom, this.urls.personal, this.urls.payment),
      onChange: partial(this.updateData, 'personal'),
      data: personal,
      quote,
      minAge: 16,
      dataLayer: {
        formname: 'Maturaball-Versicherung',
        action: 'Schritt 2 von 4'
      },
      paymentFrequency: 0,
      renderSummaryBox: this.renderSummaryBox()
    };

    return <PersonalData {...props} />;
  };

  renderPaymentPage = () => {
    if (!Object.keys(this.data.personal).length) {
      return <Navigate replace to={this.urls.personal} />;
    }

    const {
      event: { veranstaltungsArt, veranstaltungsDatum, veranstaltungsOrt, schuleUndKlasse },
      quote
    } = this.data;

    const props = {
      type: veranstaltungsArt,
      quote,
      eventDate: veranstaltungsDatum,
      location: veranstaltungsOrt,
      schoolAndClass: schuleUndKlasse,
      calculateQuote: this.calculateQuote,
      ...this.makeLinks(this.urls.personal, this.urls.payment, this.urls.confirm),
      onChange: partial(this.updateData, 'payment'),
      data: this.data.payment,
      renderSummaryBox: this.renderSummaryBox()
    };

    return <Payment {...props} />;
  };

  renderConfirmPage = () => {
    const { navigate } = this.props.router;
    let errorMessages = [];

    if (this.blockPayment) {
      this.blockPayment = false;
      navigate('/');
    }

    if (!Object.keys(this.data.personal) || !Object.keys(this.data.payment).length) {
      return <Navigate replace to={this.urls.personal} />;
    }

    const {
      event,
      personal,
      payment: { type: payment_type, ...payment }
    } = this.data;
    delete payment.quote;

    const { loading } = this.state;

    const props = {
      ...event,
      ...personal,
      ...payment,
      payment_type,
      loading,
      paymentPending: this.ajaxLoading,
      onRender: this.resetApiErros,
      onConfirm: this.placeOrder,
      apiErrorMessages: errorMessages.length ? errorMessages : this.state.apiErrorMessages,
      ...this.makeLinks(this.urls.payment, this.urls.confirm, null)
    };

    return <Confirmation {...props} />;
  };

  renderSuccessPage = () => {
    const { status } = this.state;
    const successMessage = (
      <React.Fragment>
        <div>{i18n('Vielen Dank!')}</div>
        <div>
          {i18n(
            'Sie haben die Veranstalter-Haftpflichtversicherung für Ihren Maturaball erfolgreich abgeschlossen. Ihre Versicherungspolizze erhalten Sie an einem der nächsten Arbeitstage per Post an die von Ihnen angegebene Adresse.'
          )}
        </div>
      </React.Fragment>
    );

    if (!Object.keys(this.data.personal).length) {
      return <Navigate replace to={this.urls.prom} />;
    }

    return (
      <PaymentSuccess
        status={status}
        onSuccess={() => {
          this.blockPayment = true;
        }}
        resetData={this.initializeData}
        message={successMessage}
      />
    );
  };

  render() {
    const prefix = window.base === '/' ? '' : window.base;

    return (
      <div>
        <Head
          title={i18n('Veranstalter-Haftpflichtversicherung für Maturabälle')}
          steps={this.steps}
          showSteps={window.location.pathname !== `${prefix}/success` && window.location.pathname !== `${prefix}/error`}
        />
        <Routes>
          <Route exact path={this.urls.prom} Component={this.renderEventDetailsPage} />
          <Route path={this.urls.personal} Component={this.renderPersonalDetailsPage} />
          <Route path={this.urls.payment} Component={this.renderPaymentPage} />
          <Route path={this.urls.confirm} Component={this.renderConfirmPage} />
          <Route path={this.urls.success} Component={this.renderSuccessPage} />
          <Route path={this.urls.error} component={<PaymentError />} />
          <Route path="/" element={<Navigate replace to={this.urls.personal} />} />
        </Routes>
      </div>
    );
  }
}

export default withRouter(PromInsurance);
